<template>
  <div v-if="client">
        <!-- token -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Token</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input
                            v-model="client.settings.gcbSettings.token"
                            class="input"
                            type="text"
                        />
                    </p>
                </div>
            </div>
        </div>

        <!-- image -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Image</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input
                            v-model="client.settings.gcbSettings.image"
                            class="input"
                            type="text"
                        />
                    </p>
                </div>
            </div>
        </div>

        <!-- save -->
        <div class="field is-horizontal">
            <div class="field-label"></div>
            <div class="field-body">
                <div class="field is-grouped">
                    <div class="control">
                        <button @click="save" class="button is-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import state from '../../../../state';
import utils from '../../../../utils';
import clientService from '../../../../services/client.service';

export default {
    name: 'client-settings-curacao',
    data() {
        return {
            client: null
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        }
    },
    watch: {
        clientId() {
            this.loadClient();
        }
    },
    async mounted() {
        await clientService.ensure();
        this.loadClient();
    },
    methods: {
        loadClient() {
            this.client = utils.clone(state.clients.getClient(this.clientId));
        },
        async save() {
            await clientService.save(this.client);
        }
    }
};
</script>

<style>

</style>


// WEBPACK FOOTER //
// front/src/components/clients/client/settings/gcb.vue